import { PrivilegedUsersBlockPage } from '../screens/PrivilegedUsersBlockPage/PrivilegedUsersBlockPage';
import { PrivilegedUsersWrapper } from '../PrivilegeUserWarpper';
import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { Pages, Roles } from '../../../context/contexts/UserContext/permissionsTypes';
import { LogicalRoute, LogicalRouteImportProps } from '../../../routings/helpers/LogicalRoute';
import useHasPermissions from '../../../hooks/useHasPermissions';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const PrivilegeAccountsRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();
    const displayBlockPage = isPageBlocked(LAYOUT_TABS.PRIVILEGED_ACCOUNTS.ID);
    const disabled = !useHasPermissions({ permission: Pages.PRIVILEGED_ACCOUNTS, role: Roles.VIEWER });

    return (
        <LogicalRoute
            {...props}
            component={PrivilegedUsersWrapper}
            blockPageComponent={PrivilegedUsersBlockPage}
            displayBlockPage={displayBlockPage}
            disabled={disabled}
        />
    );
};
